import { render, staticRenderFns } from "./SubClinic.vue?vue&type=template&id=1ccf3a04&"
import script from "./SubClinic.vue?vue&type=script&lang=js&"
export * from "./SubClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports